<template>
  <b-container class="pl-0 pr-0">
    <b-row>
      <b-col>
        <template v-if="insightsProducts">
          <!-- highcharts -->
          <scoring-definition-distribution-chart
            :data="insightsProductsMappedForChart"
            :chart-title="$t('scoringProfiles.distributionChart')"
            :is-empty-set="isEmptySet"
            v-on:column-click="showDistributionScoreData"
          ></scoring-definition-distribution-chart>
          <b-row class="mt-3 custom-chart-bottom-space">
            <b-col v-for="(item, index) in distributionChartParamsLegend" :key="index">
              <div class="text-center">
                <div :class="['legend-pill d-inline-block', item.class]"></div>
                <div class="ml-2 d-inline-block align-baseline">{{ item.name }}</div>
              </div>
            </b-col>
          </b-row>
        </template>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ScoringDefinitionDistributionChart from '../../components/ScoringProfiles/ScoringDefinitionDistributionChart'

export default {
  components: {
    ScoringDefinitionDistributionChart,
  },
  props: {
    insightsProducts: {
      type: Object,
      default: null,
    },
    insightsPerimeter: {
      type: Array,
      default: () => [],
    },
    scoringProfileId: {
      type: String,
      default: null,
    },
  },
  methods: {
    showDistributionScoreData(value, item) {
      this.$emit('show-distribution-score', value, item)
    },
  },
  computed: {
    distributionChartParamsLegend() {
      return [
        {
          name: this.$tc('scoringProfiles.insight.productsMarketSegment'),
          class: 'legend-pill-segment',
        },
        {
          name: this.$tc(
            'scoringProfiles.insight.productsUnderTesting',
            this.insightsProducts ? this.insightsProducts.productsUnderTesting.length : 0
          ),
          class: 'legend-pill-primary',
        },
        {
          name: this.$tc(
            'scoringProfiles.insight.ownedMarketProducts',
            this.insightsProducts ? this.insightsProducts.productsUnderDistribution.length : 0
          ),
          class: 'legend-pill-distribution',
        },
      ]
    },
    insightsProductsMappedForChart() {
      if (!this.insightsProducts) {
        return []
      }
      let sets = this.insightsProducts
      Object.keys(sets).map((key) => {
        sets[key] = sets[key].filter(
          (x) => Object.keys(x).length > 0 && x.score != null && !isNaN(x.score) && x.score !== 0
        )
      })
      return sets
    },
    isEmptySet() {
      return Object.values(this.insightsProductsMappedForChart).every((set) => set.length === 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.legend-pill {
  padding: 0.3rem;
}
.legend-pill-segment {
  background-color: #95ceff !important;
}
.legend-pill-primary {
  background-color: var(--primary) !important;
}
.legend-pill-distribution {
  background-color: #f8dcb6 !important;
}
.custom-chart-bottom-space {
  margin-bottom: 2.5rem;
}
</style>
